export const ROULETTE_BLANK_IMAGE_SRC =
  '/assets/pngs/benefit-partner-point-shop/roulette-blank.png';

//* 서버 계약 — 참여당 광고 재도전 최대 2회(첫 회는 무료로 노출).
export const ROULETTE_MAX_RETRY_COUNT = 2;
